import React, { useState, useRef, useEffect } from "react";
import "../../assets/css/Secretsanta.css";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { useAuth } from '../../context/AuthContext';
import config from '../../config';
import { getSocket } from '../../context/socket'; // adjust path as needed
import { Image } from 'primereact/image';

const Giftlist = ({ onClose, eventID }) => {
    const { accessToken, userId, role, username } = useAuth();
    const toast = useRef(null);
    const [selectedIndex, setSelectedIndex] = useState(null);
    const socket = getSocket();
    const [giftList, setGiftList] = useState([]);
    const [selectedGift, setSelectedGift] = useState(null);

    // Fetch available participant gifts
    useEffect(() => {
        if (!socket || !eventID) return;

        socket.emit("fetchSantaParticipantData", { event_id: eventID });

        socket.once("santaParticipantData", (res) => {
            if (res.success) {
                setGiftList(res.data);
            } else {
                toast.current.show({
                    severity: "error",
                    summary: "Error",
                    detail: res.message,
                });
            }
        });
    }, [socket, eventID]);

    const handleSelect = (gift) => {
        setSelectedGift(gift);
    };

    const handleGiftSelectionSave = () => {
        if (!selectedGift) return;

        socket.emit("updateSantaDrawGift", {
            event_id: eventID,
            giver_id: userId,
            participant_id: selectedGift.participant_id,
            image_url: selectedGift.image_url,
            amazon_url: selectedGift.amazon_url
        });

        socket.once("updateSantaDrawGiftResponse", (res) => {
            if (res.success) {
                onClose();
            } else {
                toast.current.show({
                    severity: "error",
                    summary: "Error",
                    detail: res.message,
                });
            }
        });
    };

    return (
        <div>
            <Toast ref={toast} />
            <h5 className="mb-4 pb-3 border-bottom text-danger">Select Gift</h5>

            <ul className="gift-list">
                {giftList.map((item) => {
                    const isDisabled = item.is_active === false;
                    const isSelected = selectedGift?.participant_id === item.participant_id;

                    return (
                        <li
                            key={item.participant_id}
                            onClick={() => !isDisabled && handleSelect(item)} // 🔹 Prevent click
                            className={
                                `${isSelected ? "selected-li" : ""} ` +
                                `${isDisabled ? "disabled-li" : ""}`
                            }
                        >
                            <div className="gftText">
                                <Image 
                                    src={item.image_url}
                                    alt="gift"
                                    style={{ width: "100px", borderRadius: "10px", opacity: isDisabled ? 0.5 : 1 }}
                                    preview 
                                />
                                <div className="d-flex flex-column gap-2">
                                    <p class="url-wrapper">
                                        <span class="two-line-ellipsis">
                                            {item.amazon_url || "No link"}
                                        </span>
                                    </p>
                                    <small>
                                        {isDisabled && (
                                            <small style={{fontWeight: '600', paddingLeft: '15px'}}>
                                                Already Taken
                                            </small>
                                        )}
                                    </small>
                                </div>
                            </div>
                        </li>
                    );
                })}
            </ul>

            {selectedGift && (
                <Button
                    label="Save Gift"
                    severity="danger"
                    className="py-2 mt-4 d-block w-100"
                    onClick={handleGiftSelectionSave}
                />
            )}

        </div>
    )
}

export default Giftlist